var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"columns"},[_c('div',{staticClass:"column is-one-fifth"},[_c('sidepanel')],1),_c('div',{staticClass:"column"},[_c('div',{staticClass:"content"},[_c('router-view')],1)])])])
}
var staticRenderFns = []

export { render, staticRenderFns }